import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectorAuth } from './auth.reducer';

@Injectable()
export class LoginGuardService implements CanActivate {
  isAuthenticated = false;

  constructor(
    private store: Store<any>,
    private router: Router
  ) {
    this.store
      .select(selectorAuth)
      .subscribe(authStore => {
        this.isAuthenticated = authStore ? authStore.isAuthenticated : false;
      });
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.isAuthenticated) {
      return true;
    } else {
      this.router.navigateByUrl('/');
      return false;
    }
  }
}
